import Customers        from "../../../../domain/customer/Customers";
import MailGroups       from "../../../../domain/mail/group/MailGroups";
import MailSend         from "../../../../domain/mail/send/MailSend";
import MailSendContent  from "../../../../domain/mail/send/MailSendContent";
import MailSendSubject  from "../../../../domain/mail/send/MailSendSubject";
import ResKaReduxAction from "../../ResKaReduxAction";

export enum ACTION_TYPE {
  SET_MAIL_SEND = "SET_MAIL_SEND",
  SET_MAIL_SEND_GROUPS = "SET_MAIL_SEND_GROUPS",
  SET_MAIL_SEND_CUSTOMERS = "SET_MAIL_SEND_CUSTOMERS",
  SET_MAIL_SEND_SUBJECT = "SET_MAIL_SEND_SUBJECT",
  SET_MAIL_SEND_CONTENT = "SET_MAIL_SEND_CONTENT",
}

export interface SetMailSendAction extends ResKaReduxAction {
  mailSend: MailSend;
}

export interface SetMailSendGroupsAction extends ResKaReduxAction {
  mailGroups: MailGroups;
}

export interface SetMailSendCustomersAction extends ResKaReduxAction {
  customers: Customers;
}

export interface SetMailSendSubjectAction extends ResKaReduxAction {
  mailSendSubject: MailSendSubject;
}

export interface SetMailSendContentAction extends ResKaReduxAction {
  mailSendContent: MailSendContent;
}

export type MailSendAction =
  SetMailSendAction
  | SetMailSendGroupsAction
  | SetMailSendCustomersAction
  | SetMailSendSubjectAction
  | SetMailSendContentAction
  ;

export const setMailSendAction = (mailSend: MailSend): SetMailSendAction => ({
  type: ACTION_TYPE.SET_MAIL_SEND,
  mailSend: mailSend,
});

export const setMailSendGroupsAction = (mailGroups: MailGroups): SetMailSendGroupsAction => ({
  type: ACTION_TYPE.SET_MAIL_SEND_GROUPS,
  mailGroups: mailGroups,
});

export const setMailSendCustomersAction = (customers: Customers): SetMailSendCustomersAction => ({
  type: ACTION_TYPE.SET_MAIL_SEND_CUSTOMERS,
  customers: customers,
});

export const setMailSendSubjectAction = (mailSendSubject: MailSendSubject): SetMailSendSubjectAction => ({
  type: ACTION_TYPE.SET_MAIL_SEND_SUBJECT,
  mailSendSubject: mailSendSubject,
});

export const setMailSendContentAction = (mailSendContent: MailSendContent): SetMailSendContentAction => ({
  type: ACTION_TYPE.SET_MAIL_SEND_CONTENT,
  mailSendContent: mailSendContent,
});